import React, { useState } from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

function ProjectCards(props) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <div className="project-card-outer">
        <Card
          className="project-card-inner"
          onClick={handleShow}
          style={{ cursor: "pointer", position: "relative" }}
        >
          {/* Date Badge */}
          {props.date && (
            <div
              style={{
                position: "absolute",
                top: "12px",
                left: "12px",
                backgroundColor: "rgba(20, 35, 44, 0.9)",
                color: "#8DE1FC",
                padding: "4px 10px",
                borderRadius: "6px",
                fontSize: "0.85rem",
                fontWeight: "600",
                zIndex: 1,
                border: "1px solid rgba(141, 225, 252, 0.3)",
              }}
            >
              {props.date}
            </div>
          )}

          <Card.Img variant="top" src={props.imgPath} alt="card-img" loading="lazy" />

          <Card.Body>
            <Card.Title>{props.title}</Card.Title>

            <Card.Text style={{ textAlign: "justify" }}>
              {props.description}
            </Card.Text>

          </Card.Body>
        </Card>
      </div>

      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        centered
        dialogClassName="project-modal"
      >
        {/* HEADER */}
        <Modal.Header
  closeButton
  style={{
    background: "#14232c",
    borderBottom: "1px solid #254457",
  }}
>
  <div style={{ display: "flex", alignItems: "center", gap: "12px", width: "100%" }}>
    <h5 style={{ color: "#DFF8FF", margin: 0 }}>
      {props.title}
    </h5>
    {props.date && (
      <span style={{ 
        fontSize: "0.85rem", 
        color: "#8DE1FC",
        fontWeight: "500",
        backgroundColor: "rgba(141, 225, 252, 0.15)",
        padding: "4px 10px",
        marginLeft: "10px",
        borderRadius: "6px",
        border: "1px solid rgba(141, 225, 252, 0.3)"
      }}>
        {props.date}
      </span>
    )}
  </div>
</Modal.Header>

        {/* BODY */}
        <Modal.Body style={{ background: "linear-gradient(#14232c, #2b556e)" }}>
          <div style={{ position: "relative", marginBottom: "2rem" }}>
            {/* Desktop Image */}
            {props.imgPath && (
              <img
                src={props.imgPath}
                alt={`${props.title} screenshot`}
                loading="lazy"
                style={{
                  width: "100%",
                  borderRadius: "14px",
                  filter: "drop-shadow(0 8px 16px rgba(0,0,0,0.4))",
                }}
              />
            )}

            {/* Mobile overlay */}
            {props.mobileImg && (
              <img
                src={props.mobileImg}
                alt={`${props.title} mobile screenshot`}
                loading="lazy"
                style={{
                  position: "absolute",
                  bottom: "-20px",
                  right: "10px",
                  width: "30%",
                  borderRadius: "12px",
                  transform: "rotate(2deg)",
                  filter: "drop-shadow(0 8px 16px rgba(0,0,0,0.4))",
                }}
              />
            )}
          </div>

          {/* Case Study */}
          {props.caseStudy && (
            <div style={{ marginBottom: "1.5rem" }}>
              <h5 style={{ fontWeight: "600", color: "#8DE1FC" }}>Case Study</h5>
              <p style={{ textAlign: "justify", color: "#FFF" }}>
                {props.caseStudy}
              </p>
            </div>
          )}

          {/* Features */}
          {props.features && props.features.length > 0 && (
            <div style={{ marginBottom: "1.5rem" }}>
              <h5 style={{ fontWeight: "600", color: "#8DE1FC" }}>Key Features</h5>
              <ul style={{ color: "#FFF" }}>
                {props.features.map((feat, idx) => (
                  <li key={idx}>{feat}</li>
                ))}
              </ul>
            </div>
          )}
        </Modal.Body>

        {/* FOOTER */}
        <Modal.Footer
          style={{
            background: "#2b556e",
            borderTop: "1px solid #1a303d",
          }}
        >
          {props.demoLink && (
            <Button
              style={{
                backgroundColor: "#092a3a",
                borderColor: "#bdbdbdff",
                color: "#FFF",
              }}
              href={props.demoLink}
              target="_blank"
            >
              View Live
            </Button>
          )}

          {props.ghLink && (
            <Button
              style={{
                backgroundColor: "#ffffff",
                borderColor: "#ffffff",
                color: "#155674ff",
              }}
              href={props.ghLink}
              target="_blank"
            >
              GitHub
            </Button>
          )}

          <Button
            onClick={handleClose}
            style={{
              backgroundColor: "#94c9e4ff",
              borderColor: "#092a3a",
              color: "#092a3a",
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ProjectCards;